<template>
  <div v-observe-visibility="visibilityOptions">
    <a-comments-widget v-if="isLazyLoaded" v-bind="$attrs" v-on="$listeners" />
  </div>
</template>

<script>
import {
  OBSERVER_CALLBACK_DEFAULT_THROTTLE,
  OBSERVER_DEFAULT_ROOT_MARGIN
} from 'enums/mutation-observer'

const WIDGET_START_RENDER_DELAY = 1000

export default {
  name: 'ACommentsWidgetLazyLoad',
  components: {
    ACommentsWidget: () => import('./index')
  },
  data() {
    return {
      isLazyLoaded: false,
      visibilityOptions: {
        callback: this.loadComponent,
        throttle: OBSERVER_CALLBACK_DEFAULT_THROTTLE,
        once: true,
        intersection: {
          rootMargin: OBSERVER_DEFAULT_ROOT_MARGIN
        }
      }
    }
  },
  methods: {
    loadComponent(isVisible) {
      if (!isVisible) return

      this.renderWidget()
    },
    renderWidget() {
      this.isLazyLoaded = true
    }
  },
  mounted() {
    setTimeout(this.renderWidget, WIDGET_START_RENDER_DELAY)
  }
}
</script>
